<template>
  <!--begin::countriesIndex-->
  <div class="row gy-5 g-xl-8">
    <CountriesIndex
      widget-classes="card-xxl-stretch mb-5 mb-xl-8"
    ></CountriesIndex>
  </div>
  <!--end::countriesIndex-->
</template>

<script lang="js">
import { defineComponent, onMounted } from "vue";
import CountriesIndex from "@/components/system/CountriesIndex.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "CountriesView",
  components: {
    CountriesIndex
  },
  mounted() {
    setCurrentPageTitle("Countries");
  }
});
</script>
